import { Swiper } from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";

import { createSwiper } from "../../application/utils/swiper";

export const BlockCaseStudiesSlider = () => {
	const BlockCaseStudiesSliderObject = {
		swiper: null as Swiper | null,
		_init(): void {
			this.swiper = createSwiper(
				'[data-swiper="case-studies"]',
				"slide",
				{
					modules: [Autoplay, EffectFade],
					autoplay: {
						delay: 6500,
						disableOnInteraction: true,
						pauseOnMouseEnter: true,
					},
					effect: "fade",
					fadeEffect: {
						crossFade: true,
					},
					slidesPerView: 1,
					spaceBetween: 24,
					speed: 900,
					centeredSlides: false,
					direction: "horizontal",
					loop: true,
					mousewheel: false,
				},
			);
		},
	};

	BlockCaseStudiesSliderObject._init();
	return BlockCaseStudiesSliderObject;
};
